import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";

import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

const app = <App />;

/** プリレンダ済み HTML がある場合は hydration（コラム SEO） */
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
